import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'
import { Transaction } from '../../../../../app/entities/Transaction'
import { comissionPercentage } from '../../../../../app/utils/comissionPercentage'
import { formatMoneyValue } from '../../../../../app/utils/formatMoneyValue'
import Status from '../../../../components/Status'
import { getImageByType } from '@/app/utils/getImageByType'

const columnHelper = createColumnHelper<Transaction>()

const columnsSellerTransactions = [
  columnHelper.accessor('contract', {
    id: 'contract',
    header: () => (
      <div className="flex flex-col items-start pl-2 xl:items-center xl:pl-0">
        Contrato
      </div>
    ),
    cell: ({ row }) => (
      <div className="hidden pl-4 text-left xl:block">
        {String(row.original.contract).length !== 24
          ? row.original.contract
          : '-'}
      </div>
    ),
  }),
  columnHelper.accessor('type', {
    id: 'type',
    header: () => <div className="hidden pl-2 text-left xs:block">Produto</div>,
    cell: ({ row }) => {
      const type = row.original.type
      const imageSrc = getImageByType(type)

      return (
        <div className="hidden items-center justify-start pl-6 text-left xs:flex">
          <img
            src={imageSrc}
            className="mb-1 h-8 w-8 rounded-lg object-contain"
            alt={type}
          />
        </div>
      )
    },
  }),
  columnHelper.accessor('customer', {
    id: 'customer',
    header: () => (
      <div className="flex flex-col items-start gap-1 pl-2 xl:pl-0">
        <div>Cliente</div>
        <div className="block text-black04 2xl:hidden">Data</div>
        <div className="block text-black04 xl:hidden">Contrato</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col items-start gap-1 pl-4 xl:pl-0">
        <div>{row.original.customer.name}</div>
        <div className="block text-black04 2xl:hidden">
          {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
        </div>
        <div className="block text-black04 xl:hidden">
          {String(row.original.contract).length !== 24
            ? row.original.contract
            : '-'}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('value', {
    id: 'value',
    header: () => (
      <div className="flex flex-col items-end pr-2 lg:items-center lg:pr-0">
        <div>Valor</div>
        <div className="block text-black04 lg:hidden">Comissão</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col items-end pr-4 lg:items-center lg:pr-0">
        <div>{formatMoneyValue(row.original.value)}</div>
        <div className="block text-black04 lg:hidden">
          {formatMoneyValue(row.original.commission)}{' '}
          {comissionPercentage(row.original.value, row.original.commission)}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('commission', {
    id: 'comission',
    header: () => <div className="hidden lg:block">Comissão</div>,
    cell: ({ row }) => (
      <div className="hidden lg:block">
        {formatMoneyValue(row.original.commission)}{' '}
        {comissionPercentage(row.original.value, row.original.commission)}
      </div>
    ),
  }),

  columnHelper.accessor('createdAt', {
    id: 'data',
    header: () => <div className="hidden text-center 2xl:block">Data</div>,
    cell: ({ row }) => (
      <div className="hidden text-center 2xl:block">
        {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
      </div>
    ),
  }),
  columnHelper.accessor('actualStatus', {
    id: 'actualStatus',
    header: () => <div className="hidden pr-3 text-end xl:block">Status</div>,
    cell: ({ row }) => (
      <div className="hidden xl:block">
        <div className="flex items-center justify-end pr-4">
          <Status status={row.getValue('actualStatus')} />
        </div>
      </div>
    ),
  }),
]

export const ColumnDefinitionSellerTransaction = () => {
  return {
    columnsSellerTransactions,
  }
}
